// @greenlight-spec: 12-azure-installation.md
// @greenlight-spec: 28-it-dashboard-ui.md

import { FirstAppPrompt } from '@/components/greenlight/FirstAppPrompt';
import { StepHeader } from '@/components/install/StepHeader';
import { Button } from '@/components/ui/button';

interface SummaryStepProps {
  /** True until every other step is complete — finishing writes `installed_at`. */
  blocked: boolean;
  /** Records the install as finished and opens the dashboard at `destination`. */
  onFinish: (destination: '/apps' | '/integrations') => void;
  isSubmitting: boolean;
}

export function SummaryStep({ blocked, onFinish, isSubmitting }: SummaryStepProps) {
  return (
    <div className="space-y-6" data-testid="step-summary">
      <StepHeader step="summary" title="Installation complete">
        Greenlight is fully configured.
      </StepHeader>

      <FirstAppPrompt />

      {blocked ? (
        <div
          className="rounded-lg border border-dashed p-4 text-sm text-muted-foreground"
          data-testid="step-blocked"
        >
          Finishing stays available until every earlier step is complete. Go back to the first
          incomplete step to continue the install.
        </div>
      ) : (
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button
            type="button"
            className="w-full sm:w-auto h-11 md:h-9"
            onClick={() => onFinish('/apps')}
            disabled={isSubmitting}
            data-testid="step-finish"
          >
            {isSubmitting ? 'Finishing…' : 'Go to Apps'}
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full sm:w-auto h-11 md:h-9"
            onClick={() => onFinish('/integrations')}
            disabled={isSubmitting}
            data-testid="set-up-integrations"
          >
            Set up integrations
          </Button>
        </div>
      )}
    </div>
  );
}
